// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body,
html {
  scroll-behavior: smooth;
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Libre Franklin', sans-serif !important;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

:root {
  --primary-color: #eaa637;
}

:root {
  /*====== colors ==========*/
  --body-color: #e4e9f7;
  --sidebar-color: #fff;
  --primary-color: #eaa637;
  --primary-color-light: #f6f5ff;
  --secondary-color: #172639;
  --submit-color: #04aa6d;

  /*====== Transition ======*/
  --tran-02: all 0.2s ease;
  --tran-03: all 0.3s ease;
  --tran-04: all 0.4s ease;
  --tran-05: all 0.5s ease;

  /*========= width ================*/

  --sidebar-width: 230px;
  --padding-sm: 10px;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,oDAAoD;AACtD;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;;EAEvB,2BAA2B;EAC3B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,mCAAmC;;EAEnC,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody,\nhtml {\n  scroll-behavior: smooth;\n  overflow-x: hidden;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-family: 'Libre Franklin', sans-serif !important;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n:root {\n  --primary-color: #eaa637;\n}\n\n:root {\n  /*====== colors ==========*/\n  --body-color: #e4e9f7;\n  --sidebar-color: #fff;\n  --primary-color: #eaa637;\n  --primary-color-light: #f6f5ff;\n  --secondary-color: #172639;\n  --submit-color: #04aa6d;\n\n  /*====== Transition ======*/\n  --tran-02: all 0.2s ease;\n  --tran-03: all 0.3s ease;\n  --tran-04: all 0.4s ease;\n  --tran-05: all 0.5s ease;\n\n  /*========= width ================*/\n\n  --sidebar-width: 230px;\n  --padding-sm: 10px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
